<template>
  <div class="purchaseOrderOverview">
    <h3>{{ i18n.t('/Dashboard/PurchaseOrders/PageTitle') }}</h3>
    <form class="searchForm" @submit.prevent="submit">
      <app-form-field id="searchQueryTextbox" title="zoeken" :show-label="false">
        <div class="searchInput">
          <input id="searchQueryTextbox" v-model="searchQuery" type="search" title="zoek" />
          <app-button
            data-qa="search-purchase-orders-button"
            class="searchButton"
            button-type="submit"
          >
            <icon icon="search" />
          </app-button>
        </div>
      </app-form-field>

      <app-button
        class="toggleButton"
        data-qa="toggle-own-all-purchase-orders-button"
        @click="toggleOwnOrAllPurchaseOrders()"
        >{{ toggleButtonText }}</app-button
      >
    </form>

    <div class="overview-block">
      <div class="header row">
        <div class="title">{{ i18n.t('/Dashboard/Headers/Name') }}</div>
        <div class="amount">{{ i18n.t('/Dashboard/Headers/Amount') }}</div>
        <div class="customer">{{ i18n.t('/Dashboard/Headers/Customer') }}</div>
        <div class="salesemployee">
          {{ i18n.t('/Dashboard/Headers/Employee') }}
        </div>
        <div class="status">{{ i18n.t('/Dashboard/Headers/Status') }}</div>
        <div class="actions" />
      </div>
      <ul>
        <purchase-order-row
          v-for="purchaseOrder in purchaseOrders"
          :key="purchaseOrder.PurchaseOrderId"
          :purchase-order="purchaseOrder"
        />
      </ul>
    </div>
    <div class="loaderWrapper">
      <loader v-if="isLoading" />
    </div>
    <div>
      <app-button data-qa="load-purchase-orders-button" @click="loadMore()">{{
        i18n.t('/Dashboard/LoadMore')
      }}</app-button>
    </div>
  </div>
</template>

<script>
import StoreConnector from '@/helpers/StoreConnector'
import purchaseOrderService from '@/services/purchaseOrderService.js'
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import Loader from '@/components/generic/presentational/atoms/loader/Loader.vue'
import PurchaseOrderRow from '@/components/generic/presentational/organisms/purchaseOrderOverview/purchaseOrderRow.vue'
import AppFormField from '@/components/generic/presentational/atoms/formField/FormField.vue'
import Icon from '@/components/generic/presentational/atoms/icon/Icon.vue'

export default {
  components: {
    AppButton,
    Loader,
    PurchaseOrderRow,
    AppFormField,
    Icon,
  },
  data() {
    return {
      purchaseOrders: [],
      currentPage: 1,
      searchQuery: '',
      showOnlyOwnPurchaseOrders: true,
      isLoading: false,
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  computed: {
    toggleButtonText() {
      const textLabel = this.showOnlyOwnPurchaseOrders ? 'ShowAll' : 'ShowMine'
      return this.i18n.t('/Dashboard/PurchaseOrders/' + textLabel)
    },
  },
  async created() {
    StoreConnector.get('purchaseOrder/all', (data) => {
      this.purchaseOrders = data
    })

    await this.fetchPurchaseOrders()
  },
  methods: {
    async toggleOwnOrAllPurchaseOrders() {
      this.showOnlyOwnPurchaseOrders = !this.showOnlyOwnPurchaseOrders
      this.currentPage = 1
      purchaseOrderService.resetPurchaseOrders()
      await this.fetchPurchaseOrders()
    },
    async loadMore() {
      this.currentPage++
      await this.fetchPurchaseOrders()
    },
    async fetchPurchaseOrders() {
      this.isLoading = true
      const ponId = this.showOnlyOwnPurchaseOrders ? window.info.user.UserInfo.UserName : null
      const query = this.searchQuery.length > 0 ? this.searchQuery : null

      if (this.currentPage == 1) purchaseOrderService.resetPurchaseOrders()

      await purchaseOrderService.getPurchaseOrders(this.currentPage, ponId, query)
      this.isLoading = false
    },
    async submit() {
      this.currentPage = 1
      this.fetchPurchaseOrders()
    },
  },
}
</script>

<style lang="scss" scoped>
:deep() {
  .row {
    border-bottom: 1px solid #dae2e5;
    padding: 0.5rem;
    grid-column-gap: 0.5rem;
    display: grid;
  }

  .row {
    grid-template-columns: 13fr 3fr repeat(3, 10fr) 9fr;
    grid-template-areas: 'title amount customer salesemployee status actions';
  }

  li.row:hover {
    background-color: #fafbfc;
    cursor: pointer;
  }
}

.purchaseOrderOverview {
  display: grid;
  row-gap: 20px;
}

.header {
  background-color: #f1f4f5;
  font-weight: $font-weight-bold;
}

ul {
  list-style: none outside;
}

.searchForm {
  display: flex;
  flex-flow: row wrap;
}

.searchButton {
  border-radius: 0.125em;
}

.searchButton svg {
  width: 1em;
  height: 1em;
}

.toggleButton {
  margin-left: 25px;
}

.loaderWrapper {
  display: grid;
}
</style>
